import axios from 'axios'

export async function renameCustomLocation(id, name){
    return await axios.put(process.env.VUE_APP_API_HOST + '/custom_location_group/' + id,
    {
      name
    });
  }

  export async function deleteCustomLocation(customLocationId){
    return await axios.put(process.env.VUE_APP_API_HOST + '/custom_location_group/' + customLocationId, {

      is_deleted: true

    }
    )
  }

  export async function updateCustomLocation(loc_id, name, is_shared=false){
    return await axios.put(process.env.VUE_APP_API_HOST + '/custom_location_group/' + loc_id,
    {
      name: name,
      is_shared_with_account: is_shared
    });
  }
